import { DataTableTypes } from '../../DataTableTypes';

export const dataTableDefaultProps = {
  limit: 30,
  offset: 0,
  totalCount: 0,
  loading: false,
  expandable: false,
  columnManagement: true,
  resizable: true,
  selectable: undefined
} as const;

export const dataTableDefaultFeatures = {
  expandable: {
    enabled: dataTableDefaultProps.expandable,
    key: undefined
  },
  columnManagement: {
    enabled: dataTableDefaultProps.columnManagement,
    resizable: {
      enabled: dataTableDefaultProps.resizable,
      mode: 'onChange',
      direction: 'ltr'
    }
  },
  selectable: {
    enabled: !!dataTableDefaultProps.selectable,
    key: undefined
  }
} satisfies Partial<DataTableTypes.DerivedState<any>>['features'];
